import styled from 'styled-components'

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 32px 0;
  flex-wrap: wrap;

  .page-numbers {
    display: flex;
    gap: 4px;
  }
`

export const PageButton = styled.button<{
  active?: boolean
  disabled?: boolean
}>`
  background: ${(props) => (props.active ? '#000' : '#fff')};
  color: ${(props) => (props.active ? '#fff' : '#000')};
  border: 1px solid ${(props) => (props.active ? '#000' : '#e0e0e0')};
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${(props) => (props.active ? '#333' : '#f5f5f5')};
    border-color: #333;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const PageInfo = styled.span`
  margin-left: 16px;
  font-size: 14px;
  color: #666;
`
